import { render, staticRenderFns } from "./admitCardCountByCollege.vue?vue&type=template&id=37c7b1fc&scoped=true&"
import script from "./admitCardCountByCollege.vue?vue&type=script&lang=js&"
export * from "./admitCardCountByCollege.vue?vue&type=script&lang=js&"
import style0 from "./admitCardCountByCollege.vue?vue&type=style&index=0&id=37c7b1fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7b1fc",
  null
  
)

export default component.exports